// import Button from "@mostrans/web-components/components/base/Button";
// import { Grid } from "@mui/material";
// import React from "react";
// import { NavLink } from "react-router-dom";
// import { useRecoilValue } from "recoil";
// import { userDataSelector } from "../../shared/globalStates";
// import logo from "../../components/Layout/assets/logo-mostrans.png";

// function NavBar() {
//   const isLoggedIn = useRecoilValue(userDataSelector);
//   return (
//     <section className="Navbar">
//       <nav className="navbar navbar-expand-lg navbar-light">
//         <div className="container-fluid">
//           <Link className="navbar-brand" to="/">
//             <img
//               className="img-fluid"
//               src={logo}
//               alt="logo mostrans"
//               width="100px"
//             />
//           </Link>
//           <button
//             className="navbar-toggler"
//             type="button"
//             data-toggle="collapse"
//             data-target="#navbarSupportedContent"
//             aria-controls="navbarSupportedContent"
//             aria-expanded="false"
//             aria-label="Toggle navigation">
//             <span className="navbar-toggler-icon"></span>
//           </button>
//           <div className="collapse navbar-collapse" id="navbarSupportedContent">
//             <div className="navbar-nav px-5 ml-auto">
//               <a href="https://mostrans.co.id/" className="nav-link">
//                 Home
//               </a>
//               <NavLink to="/" className="nav-link">
//                 Career
//               </NavLink>
//               <div className="vertical-line mr-3"></div>
//               <Grid container spacing={2}>
//                 <Grid item>
//                   <Link to="/login" style={{ textAlign: "center" }}>
//                     <Button variant="contained" color="primary">
//                       {isLoggedIn ? (
//                         <span className="material-icons">person</span>
//                       ) : (
//                         "Candidate"
//                       )}
//                     </Button>
//                   </Link>
//                 </Grid>
//                 {!isLoggedIn && (
//                   <Grid item>
//                     <Link to="/Admin/login" style={{ textAlign: "center" }}>
//                       <Button variant="contained" color="primary">
//                         Admin
//                       </Button>
//                     </Link>
//                   </Grid>
//                 )}
//               </Grid>
//             </div>
//           </div>
//         </div>
//       </nav>
//     </section>
//   );
// }

// export default NavBar;
import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";
import { useRecoilValue } from "recoil";
import {
  instagram,
  linkedin,
  logoBlack,
  logoMostransCareer,
  logoMostransV2,
  logoTextMostrans,
  logoWhite,
  tiktok,
} from "../../assets";
import { userDataSelector } from "../../shared/globalStates";
import "./Navbar.css";
import { menuItems } from "./menuItems";

const Navbar = () => {
  const [clicked, setClicked] = useState();
  const handleClick = () => {
    setClicked(!clicked);
  };
  const isLoggedIn = useRecoilValue(userDataSelector);
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);

  const handleScroll = () => {
    const scrollY = window.scrollY;
    setIsScrolled(scrollY > 0);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <nav
      className={`navbar_items
        ${location.pathname !== "/" ? "color-navbar" : ""} 
        ${isScrolled ? "navbar-fixed color-navbar" : ""}
        ${clicked ? "color-navbar" : ""}
      `}>
      <div className="d-flex justify-content-between gap-1 align-items-center">
        <Link className="navbar-logo" to="/">
          {/* {location.pathname === "/explorejobs" && (
            <img
              className="img-fluid"
              src={logoBlack}
              alt="Logo Mostrans Career"
              width="180px"
            />
          )} */}
          <img
            className="img-fluid"
            src={
              isScrolled || clicked || location.pathname !== "/"
                ? logoBlack
                : logoWhite
              // ? "https://ik.imagekit.io/mostrans/logo%20career%20black.png?updatedAt=1699857202983"
              // : "https://ik.imagekit.io/mostrans/logo%20career%20white.png?updatedAt=1699857202603"
            }
            alt="Logo Mostrans Career"
            width="180px"
          />
          {/* <img
            className="img-fluid"
            src={logoMostransV2}
            alt="logo mostrans"
            width="60px"
          /> */}
        </Link>
        {/* <div className="d-flex flex-column" style={{ marginTop: ".5rem" }}>
          {/* <b style={{ fontSize: "18px", letterSpacing: "0.2rem" , fontWeight: 800}}>MOSTRANS</b> *\/}
          <img loading="lazy" src={logoTextMostrans} alt="MOSTRANS" />
          <b style={{ fontSize: "13px" }} className="text-primary-main">Karir</b>
        </div> */}
      </div>
      <div className="menu_icon" onClick={handleClick}>
        <span className="material-icons text-neutral-n8">
          {clicked ? "close" : "menu"}
        </span>
      </div>
      <ul className={clicked ? "nav_menu active bg-white" : "nav_menu"}>
        <li>
          <Link
            className={`
              ${menuItems[0].cName} 
              ${location.pathname === "/" ? "active text-active" : ""} 
              ${
                isScrolled || clicked || location.pathname !== "/"
                  ? "text-neutral-n8"
                  : "text-white"
              }
            `}
            to={menuItems[0].url}>
            {menuItems[0].title}
          </Link>
        </li>
        <li>
          <Link
            className={`
              ${menuItems[1].cName} 
              ${
                location.pathname === "/explorejobs" ? "active text-active" : ""
              } 
              ${
                isScrolled || clicked || location.pathname !== "/"
                  ? "text-neutral-n8"
                  : "text-white"
              }
            `}
            to={menuItems[1].url}>
            {menuItems[1].title}
          </Link>
        </li>
        {/* <div
          className="vertical-line"
          style={{ margin: "0 2rem 0 0.5rem" }}
        ></div> */}
        {/* <li>
          {!isLoggedIn && (
            <Link
            to="/Admin/login"
            className="text-neutral-n8 "
            style={{
              textAlign: "center",
            }}>
            <Button variant="contained" color="primary" size="small">
            For Admin
            </Button>
            </Link>
            )}
          </li> */}
      </ul>
      <ul className={clicked ? "nav_menu login bg-white" : "nav_menu"}>
        <li>
          {isLoggedIn ? (
            <Link
              to="/career/home"
              className="text-neutral-n8 "
              style={{ textAlign: "center" }}>
              <span className="material-icons text-primary-main font-size-h2">
                person
              </span>
              <span className="account-name">{isLoggedIn.nama}</span>
            </Link>
          ) : (
            <Link
              to="/login"
              className="text-neutral-n8 "
              style={{ textAlign: "center" }}>
              <Button variant="contained" color="primary" size="small">
                Login
              </Button>
            </Link>
          )}
        </li>
      </ul>
      <ul className={clicked ? "nav_menu socmed bg-white" : "hide-display"}>
        <li>
          <div className="d-flex justify-content-between p-50 gap-1">
            <img
              className="icon-social"
              src={instagram}
              alt="instagram"
              onClick={() =>
                window.open(
                  "https://www.instagram.com/lifeatmostrans/",
                  "_blank"
                )
              }
            />
            <img
              className="icon-social"
              src={tiktok}
              alt="tiktok"
              onClick={() =>
                window.open("https://www.tiktok.com/@lifeatmostrans/", "_blank")
              }
            />
            <img
              className="icon-social"
              src={linkedin}
              alt="linkedin"
              onClick={() =>
                window.open(
                  "https://www.linkedin.com/company/mostrans",
                  "_blank"
                )
              }
            />
          </div>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
